/*
 * Copyright 2022. NXGN Management, LLC. All Rights Reserved.
 */

import { Injectable } from "@angular/core";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { REST_CONSTANTS } from "../utils/data.rest.constants";
import { Observable, throwError } from "rxjs";
import { PartnerCredentials } from "../models/partner-credentials";
import { catchError } from "rxjs/operators";

@Injectable({
  providedIn: "root"
})
export class PartnerService {
  constructor(private http: HttpClient) {}

  getPartners(merchantId: number): Observable<PartnerCredentials[]> {
    const url = `${REST_CONSTANTS.MERCHANT_BASE_URL_V6}/merchants/${merchantId}/partners`;
    return this.http
      .get<PartnerCredentials[]>(url, { headers: REST_CONSTANTS.JSON_HEADER })
      .pipe(catchError(PartnerService.handleError));
  }

  create(merchantId: number, partnerFields: PartnerCredentials): Observable<PartnerCredentials> {
    const url = `${REST_CONSTANTS.MERCHANT_BASE_URL_V6}/merchants/${merchantId}/partners`;

    return this.http
      .post<PartnerCredentials>(url, partnerFields, { headers: REST_CONSTANTS.JSON_HEADER })
      .pipe(catchError(PartnerService.handleError));
  }

  update(merchantId: number, partnerFields: PartnerCredentials): Observable<PartnerCredentials> {
    const url = `${REST_CONSTANTS.MERCHANT_BASE_URL_V6}/merchants/${merchantId}/partners/${partnerFields.id}`;

    return this.http
      .put<PartnerCredentials>(url, partnerFields, { headers: REST_CONSTANTS.JSON_HEADER })
      .pipe(catchError(PartnerService.handleError));
  }

  delete(merchantId: number, partnerId: number): Observable<void> {
    const url = `${REST_CONSTANTS.MERCHANT_BASE_URL_V6}/merchants/${merchantId}/partners/${partnerId}`;
    return this.http
      .delete<void>(url, { headers: REST_CONSTANTS.JSON_HEADER })
      .pipe(catchError(PartnerService.handleError));
  }

  resetPassword(merchantId: number, partnerId: number): Observable<PartnerCredentials> {
    const url = `${REST_CONSTANTS.MERCHANT_BASE_URL_V6}/merchants/${merchantId}/partners/${partnerId}`;

    return this.http
      .post<PartnerCredentials>(url, { headers: REST_CONSTANTS.JSON_HEADER })
      .pipe(catchError(PartnerService.handleError));
  }

  private static handleError(error: HttpErrorResponse) {
    return throwError(error);
  }
}
